var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24857 7.33429C8.72159 6.67746 9 5.87143 9 5C9 2.79079 7.20921 1 5 1C2.79079 1 1 2.79079 1 5C1 7.20921 2.79079 9 5 9C5.87111 9 6.67714 8.72127 7.33429 8.24857L7.88349 8.79778C8.04698 8.96127 8.31175 8.96127 8.47524 8.79778L8.79778 8.47524C8.96127 8.31175 8.96127 8.04698 8.79778 7.88349L8.24857 7.33429ZM5 7.7073C3.5073 7.7073 2.29302 6.49302 2.29302 5.00032C2.29302 3.50762 3.5073 2.29302 5 2.29302C6.4927 2.29302 7.70698 3.5073 7.70698 5C7.70698 5.51238 7.56381 5.99206 7.31524 6.40127L6.48 5.56603C6.31651 5.40254 6.05175 5.40254 5.88825 5.56603L5.56571 5.88857C5.40222 6.05206 5.40222 6.31683 5.56571 6.48032L6.40095 7.31556C5.99206 7.56413 5.51238 7.7073 4.99968 7.7073H5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/QuestionIcon.f2b6a9d5fec5e7be07cd0118de48e323.svg";
export { ForwardRef as ReactComponent };